enum Role {
  Admin = "admin",
  Owner = "owner",
  Tenant = "tenant",
  Dev = "dev",
}

export default Role;
